import useMutation from 'hooks/use-mutation';
import useRemoveNodeFromCache from 'components/canvas/hooks/use-remove-node-from-cache';
import { useTranslation } from 'i18n';
import { softDeleteSurfaceNodesMutation } from 'graphql/surface-node/mutations/soft-delete-surface-nodes';
import { toast } from 'services/toast';

import { SurfaceNodeUnion } from 'graphql/types';
import useSaveNodeInCache from 'components/canvas/hooks/use-save-node-in-cache';

export function useSoftDeleteSurfaceNodesMutation(surfaceId: string) {
  const { t } = useTranslation();
  const removeNodeFromCache = useRemoveNodeFromCache();
  const saveNodeInCache = useSaveNodeInCache();
  const [softDeleteSurfaceNodes] = useMutation(softDeleteSurfaceNodesMutation);

  return function (nodes: SurfaceNodeUnion[]) {
    nodes.forEach((node) => removeNodeFromCache(node));

    const ids = nodes.map((node) => node.id);

    return softDeleteSurfaceNodes({ variables: { ids } }).then((response) => {
      if (response.isFailure) {
        nodes.map((node) => saveNodeInCache(node));
        return toast.error(response.getErrorMessage());
      }

      toast.success(
        t(`Successfully deleted nodes {{names}}`, {
          replace: { names: nodes.map((node) => node.name).join(', ') || '' },
        }),
      );

      return response;
    });
  };
}
